//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';
import { Swipe, SwipeItem, Popup, Icon, List, Toast} from 'vant';
import { goodsItem, videoItem, commentItem, articleItem, dataController } from 'components/app';
export default {
  name: 'index',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  components: {
    Swipe, SwipeItem, Popup, Icon, List, Toast, commentItem, articleItem, goodsItem, dataController
  },
  /* created: async function () {
    await this.getInfo();
    // wx.config({
    //   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //   appId: '', // 必填，公众号的唯一标识
    //   timestamp: , // 必填，生成签名的时间戳
    //   nonceStr: '', // 必填，生成签名的随机串
    //   signature: '',// 必填，签名
    //   jsApiList: ['previewImage', 'chooseImage'] // 必填，需要使用的JS接口列表
    // });
    wx.config({
      "timeStamp": "1541499520",
      "package": "prepay_id=null",
      "paySign": "1F8C3F04332D5242ED65520BE4816587",
      "appId": "wx19bdde06f1dad969",
      "signType": "MD5",
      "nonceStr": "1541499520980"
    } )
    console.log('-----------this', this);
  }, */
  async created() {
    this.init();
  },
  data() {
    return {
      pageTitle: undefined, // 文章页标题
      articleData: {
        code: undefined,
        data: {},
        msg: undefined
      },
      emptyData: {
        text: '图文已下架',
        image: '/static/img/app/no_article.png'
      },
      bannerIndex: 0,
      loading: false,
      finished: false,
      isLiked: false,
      materialId: undefined,
      materialType: 1,
      page: 1,
      pageSize: 10,
      enterpriseNo: '',
      recommTotal: 0,
      recommentList: [],
      commentTotal: 0,
      commentData: [],
      commentNum: 0,
      isLiked: 0,
      likeNum: 0,
      hotCommentList: {
        code: undefined,
        data: [],
        msg: undefined
      },
    }
  },
  methods: {
    ...action,
  },
  computed: {
    operation () {
      const { commentNum, likeNum, isLiked} = this.articleData.data || {};
      return { commentNum, likeNum, isLiked };
    }
  },
  watch: {
    '$route' (to, from) {
      //刷新参数放到这里里面去触发就可以刷新相同界面了
      this.init();
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/app/article/page.vue